export const round = (num, decimalPlaces = 0): number => {
    // @ts-ignore
    num = Math.round(num + 'e' + decimalPlaces);
    return Number(num + 'e' + -decimalPlaces);
};
